import * as React from 'react';
const SvgMinus = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M5.792 10.541a.53.53 0 0 1-.383-.154.5.5 0 0 1-.159-.383q0-.23.156-.387a.52.52 0 0 1 .386-.159h8.416a.53.53 0 0 1 .383.155q.159.154.159.383a.53.53 0 0 1-.156.387.52.52 0 0 1-.386.158z'
            />
        </g>
    </svg>
);
export default SvgMinus;
